import React, {useEffect, useState} from 'react';
import ReactGA from 'react-ga4';
import './Home.css';
import CollectionDataCards from '../components/CollectionDataCards';
import Header from '../components/Header';
import Nav from '../components/nav';
import SideBar from '../components/CollectionDataSideBar';

ReactGA.initialize('G-FK4YHLDPRT');

function Home() {
  const [selectedSource, setSelectedSource] = useState(null);

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: window.location.pathname });
  }, []);

  return (
    <div className="App">
      <Header />
      <div className='header_spacer'></div>
      <div className='sidebar'>
        <Nav />
        <div className='notice'>
          <SideBar onSelectSource={setSelectedSource} />
        </div>
      </div>
      <div className='news_card_conatiner'>
        <h3 className='collection_title'>Collection - 数据产品</h3>
        <CollectionDataCards selectedSource={selectedSource} setSelectedSource={setSelectedSource}  />
      </div>
    </div>
  );
}

export default Home;